import HomeLayout from './views/teaser/HomeLayout'
import Homepage from './views/teaser/Homepage'

const routes = [
  { path: '/', component: HomeLayout, children: [
      { path: '', name: 'Homepage', component: Homepage },
      { path: '*', component: { render (h) { return h('div', '404. Not Found.') } } }
    ]
  },
  { path: '*', component: { render (h) { return h('div', 'Woops! 404. Not Found.') } } }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js